/* __next_internal_client_entry_do_not_use__ Synchronized auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1728))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.831Z
 */ export var Synchronized = createSVGIcon(/*#__PURE__*/ _jsx("path", {
    d: "M18.8572 15.4286L22.2857 14.5714M22.2857 14.5714L23.1429 18M22.2857 14.5714C21.523 16.7282 20.1396 18.6113 18.3094 19.9839C16.4793 21.3565 14.2842 22.1573 12.0001 22.2857C9.89044 22.2796 7.83329 21.6274 6.10558 20.4167C4.37786 19.206 3.06254 17.4951 2.33667 15.5143M5.14289 8.57143L1.71432 9.42857M1.71432 9.42857L0.857178 6M1.71432 9.42857C3.15775 5.48571 7.5755 1.71423 12.0001 1.71423C14.1097 1.7203 16.1669 2.37257 17.8946 3.58323C19.6223 4.79388 20.9376 6.5048 21.6635 8.48566",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), "Synchronized", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
